export default __webpack_public_path__ + "static/media/pic5.a9ff2eb7.jpg";